// extracted by mini-css-extract-plugin
export default {"container":"HZ-z","list":"IZ-z"};